import React from "react";
import DashTile from "./DashTile";

// Grid de tiles con el estado de cada servicio. Recibe los datos ya
// resueltos por Dashboard.js y los normaliza de forma defensiva
// (cada fetch puede devolver {} en caso de error).
const arr = (x) => (Array.isArray(x) ? x : []);

const DashTiles = ({ saldos, planesPago, prestamos, cum, horasSociales, materias, pasantias, mostrarPasantias, facturasCount, facturaNueva, facturaFecha }) => {
    const listaSaldos = arr(saldos);
    const listaPP = arr(planesPago);
    const listaPrestamos = arr(prestamos);
    const listaHoras = arr(horasSociales);

    const totalSaldo = listaSaldos.reduce((s, e) => s + (+e.saldo || 0), 0);
    const totalPP = listaPP.reduce((s, e) => s + (+e.monto || 0), 0);
    const totalGeneral = totalSaldo + totalPP;
    const alDia = totalGeneral === 0;

    const cumValor =
        Array.isArray(cum) && cum.length > 0 && cum[0] && cum[0].cum != null
            ? (+cum[0].cum).toFixed(1)
            : "—";

    const totalHoras = listaHoras.reduce((s, e) => s + (+e.horas || 0), 0);

    return (
        <div className="esen-stat-grid">
            <DashTile
                to="/saldo"
                icon="fa-usd"
                titulo="Finanzas"
                valor={`$${totalGeneral.toFixed(2)}`}
                detalle={
                    alDia
                        ? "Sin pagos pendientes"
                        : `${listaSaldos.length + listaPP.length} ${listaSaldos.length + listaPP.length === 1 ? "pago pendiente" : "pagos pendientes"}`
                }
                chip={
                    alDia
                        ? { texto: "Al día", tono: "success" }
                        : { texto: "Pendiente", tono: "danger" }
                }
            />

            <DashTile
                to="/home"
                icon="fa-graduation-cap"
                titulo="Materias"
                valor={materias || 0}
                detalle={`${materias === 1 ? "materia inscrita" : "materias inscritas"} · ver horario`}
            />

            <DashTile
                to="/notas"
                icon="fa-diamond"
                titulo="CUM"
                valor={cumValor}
                detalle="Coeficiente acumulado"
            />

            <DashTile
                to="/horassociales"
                icon="fa-hourglass-half"
                titulo="Horas sociales"
                valor={totalHoras}
                detalle={`${listaHoras.length} ${listaHoras.length === 1 ? "actividad registrada" : "actividades registradas"}`}
            />

            <DashTile
                to="/prestamos"
                icon="fa-book"
                titulo="Biblioteca"
                valor={listaPrestamos.length}
                detalle={`${listaPrestamos.length === 1 ? "libro en préstamo" : "libros en préstamo"}`}
                chip={
                    listaPrestamos.length > 0
                        ? { texto: "Activo", tono: "info" }
                        : null
                }
            />

            {mostrarPasantias ? (
                <DashTile
                    to="/pasantiasalumnos"
                    icon="fa-briefcase"
                    titulo="Pasantías"
                    valor={pasantias || 0}
                    detalle={`${pasantias === 1 ? "oferta disponible" : "ofertas disponibles"}`}
                    chip={pasantias > 0 ? { texto: "Abiertas", tono: "info" } : null}
                />
            ) : null}

            <DashTile
                to="/directorio"
                icon="fa-address-book"
                titulo="Directorio"
                detalle="Contactos y correos ESEN"
            />

            <DashTile
                to="/dtealumnos"
                icon="fa-file-text-o"
                titulo="Facturas"
                valor={facturasCount || 0}
                detalle={
                    facturaNueva && facturaFecha
                        ? `Nueva: ${facturaFecha}`
                        : facturasCount === 1
                        ? "factura emitida"
                        : "facturas emitidas"
                }
                chip={facturaNueva ? { texto: "Nueva", tono: "info" } : null}
            />
        </div>
    );
};

export default DashTiles;
